import React, { Fragment, useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Spin } from 'antd';
import _ from 'lodash';
import MainLayout from '../components/layouts/MainLayout';
import BookingList from '../components/views/BookingList';
import { alertFail } from '../components/Alert';
import * as api from '../api';
import { bookingListAction, userConfigAction } from '../stores/actions';

const BookingListContainer = ({
  history,
}) => {
  // const [ isOpenModalLocationService, setIsModalLocationServiceVisible ] = useState(false);
  const [ isOpenModalKeyIssueInfo, setIsOpenModalKeyIssueInfo ] = useState(false);
  const [ isLoading, setIsLoading ] = useState(true);
  const [ selectedBooking, setSelectedBooking ] = useState({});
  const { bookingListItems } = useSelector(state => state.bookingList);
  // const { isVisibleLocationServiceInfo, isVisibleKeyIssueInfo } = useSelector(state => state.userConfig);
  const dispatch = useDispatch();

  const openModalKeyIssueInfo = useCallback(() => {
    setIsOpenModalKeyIssueInfo(true);
  }, []);

  const closeModalKeyIssueInfo = useCallback(() => {
    setIsOpenModalKeyIssueInfo(false);
  }, []);

  const skipBookingAuth = useCallback(() => {
    dispatch(userConfigAction.setIsSkipBookingAuth(true));
  }, [dispatch]);

  const newBookingAuth = useCallback(() => {
    dispatch(userConfigAction.setIsSkipBookingAuth(false));
  }, [dispatch]);

  const listBooking = useCallback(async () => {
    try {
      const { data: bookings } = await api.listBooking();
      dispatch(bookingListAction.setBookingList(bookings.items));
      skipBookingAuth();
    } catch (error) {
      if (error.response) alertFail(error.response.data.message, 3);
      else alertFail(error.message, 3);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, skipBookingAuth]);

  const issueKey = useCallback(async () => {
    try {
      if (!_.isEmpty(selectedBooking) && !selectedBooking.pincodes.length) await api.issuePincode({bookingId: selectedBooking.id});
      if (!_.isEmpty(selectedBooking) && !selectedBooking.mobilekeys.length) await api.issueMobilekey({bookingId: selectedBooking.id});
    } catch (error) {
      throw error;
    }
  }, [selectedBooking]);

  useEffect(() => {
    if (sessionStorage.getItem('api_key')) listBooking();
    else setIsLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <Spin spinning={isLoading} tip="Loading...">
        <MainLayout
          history={history}
          ContentBody={(
              <BookingList
                // isOpenModalLocationService={isOpenModalLocationService}
                // openModalLocationService={openModalLocationService}
                // closeModalLocationService={closeModalLocationService}
                isOpenModalKeyIssueInfo={isOpenModalKeyIssueInfo}
                openModalKeyIssueInfo={openModalKeyIssueInfo}
                closeModalKeyIssueInfo={closeModalKeyIssueInfo}
                // isVisibleLocationServiceInfo={isVisibleLocationServiceInfo}
                // isVisibleKeyIssueInfo={isVisibleKeyIssueInfo}
                bookingListItems={bookingListItems}
                // verifyCurrentLocation={verifyCurrentLocation}
                listBooking={listBooking}
                issueKey={issueKey}
                selectedBooking={selectedBooking}
                setSelectedBooking={setSelectedBooking}
                newBookingAuth={newBookingAuth}
                history={history}
              />
          )}
        />
      </Spin>
    </Fragment>
  );
};

export default BookingListContainer;